module.exports = "<div id=\"alertMessage\" *ngIf=\"message\" (click)=\"closeAlert()\"\n     [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">\n  <a class=\"close\"><i class=\"fa fa-close\"></i></a>\n  {{message.text}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /root/production/sne-pro/src/app/component/alert/alert.component.html
// module id = ../../../../../src/app/component/alert/alert.component.html
// module chunks = main